import type { Company } from '../company.model';

/**
 * Canonical mock {@link Company} used by tests, MSW handlers and the
 * demo build.
 */
export const MOCK_COMPANY: Company = {
  id: 1,
  name: 'Gulf Precision Industries',
  status: 'paid',
  type: 'admin',
  createdAt: '2025-01-15T12:00:00Z',
};

/**
 * Builds a {@link Company} from {@link MOCK_COMPANY} with optional
 * overrides.
 *
 * @example
 * const supplier = createMockCompany({ name: 'My Supplier', type: 'supplier' });
 */
export function createMockCompany(overrides?: Partial<Company>): Company {
  return { ...MOCK_COMPANY, ...overrides };
}

/**
 * Builds a list of mock {@link Company} entries. IDs are auto-incremented
 * from `1` unless overridden via the per-index callback.
 */
export function createMockCompanyList(
  count = 3,
  overrideAt?: (index: number) => Partial<Company>
): Company[] {
  return Array.from({ length: count }, (_, i) =>
    createMockCompany({
      id: i + 1,
      name: `Gulf Precision Industries ${i + 1}`,
      ...overrideAt?.(i),
    })
  );
}
